exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Roboto);", ""]);

// module
exports.push([module.id, ".hero{background-color:#2c3e50;height:50rem;padding:3rem}.hero *{color:#f5f5f5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/hero/hero.scss
// module id = 460
// module chunks = 0